const inquiries = {
    '1': require('./demo_data/inquiries-list-1.json'),
    '2': require('./demo_data/inquiries-list-2.json'),
    '3': require('./demo_data/inquiries-list-3.json')
}

const inquiry = {
    '1': require('./demo_data/inquiry-1.json'),
    '2': require('./demo_data/inquiry-2.json'),
    '3': require('./demo_data/inquiry-3.json')
}

export default {
    getList(params) {
        return new Promise((resolve, reject) =>
            setTimeout(function() {
                resolve(inquiries[params.pageIndex])
                reject('Error Occured')
            }, 300)
        )
    },
    getInquiry(params) {
        return new Promise((resolve, reject) =>
            setTimeout(function() {
                if (inquiry[params.id]) {
                    resolve(inquiry[params.id])
                } else {
                    reject({ error: 'No data found' })
                }
            }, 1000)
        )
    },
    updateInquiry(params) {
        return new Promise((resolve, reject) => {
            setTimeout(function() {
                resolve(console.log('inquiryService updateInquiry', params))
                reject('Failed update inquiry')
            }, 1000)
        })
    }
}
